<template>
    <el-container class="layout-container-demo" >
      <!-- 顶部工具栏 -->
        <el-header  class="flexItems">
          <div class="header-button" @click="closeBtnCLick">返回</div>
          <div class="flex goodsTabs">
              <span v-for="(item,index) in tabsMenu" class="tabsText" :key="index" @click="handleClick(index)" :class="{activeTabs:index===activeTab}" >{{item}}</span>
          </div>
          <el-icon @click="setClick" color="#fff" size="35" style="display: flex;justify-content: end;flex:1"><Tools /></el-icon>

  
        </el-header>
        <!-- 内容 -->
        <div class="flex" style="flex:1; ">
          <!-- 左侧菜单 -->
          <el-aside width="11%" style="height:calc(100vh - 310px)">
            <el-scrollbar style="height: 100%;">
              <el-menu :default-active="menuActive" active-text-color="#fff" @select="handleSelect">
                <el-menu-item :index="index+''" v-for="(item,index) in menuList" :key="index" class="menu-item">
                   {{item.receiptorUserName}}
                </el-menu-item>
              </el-menu>
            </el-scrollbar>
          </el-aside>
          <!-- 右侧内容 -->
          <el-main style="padding:10px 10px 0 ;flex:1;height:calc(100vh - 105px)" >
            <el-scrollbar style="height: 100%;">
              <div v-for="(item,index) in tableData" :key="index" >
                  <h4 class="cont-title">{{item.supplierCcCode}}</h4>
                <div class="flex flexWrap">
                   <div  v-for="(v,i) in item.warehouseReduceRecordInfoList" :key="i"  class="entry-card-item" >
                    <el-card shadow="always" class="cont-card" >
                      <div class="flex justifyBetween">
                          <div class="card-left">
                               <h3 class="card-title font-weight-bold">{{v.goodsName}}</h3>
                               <!-- <div class="font-weight-bold">{{GetNumByUnit(v.orderNo,'g','kg')}}kg</div> -->
                             <div class="font-weight-bold">{{ activeTab==0?GetNumByUnit(v.orderNo, "g", "kg"):v.unitOrderNo }}{{activeTab==0?'kg':v.unitOrderName}}
                              <span style="font-size:12px" v-if="activeTab!=0">({{v.specFullName}})</span>
                            </div>
                               
                          </div>
                           <el-image style="width: 120px; height: 80px" :src="v.goodsImg"  />
                      </div>
                      <div class="flex justifyBetween card-bottom">
                          <div class="font-weight-bold" style="flex:1;">共计{{v.infoList&&v.infoList.length||0}}笔出仓单
                            <div class="flex" style="margin-top:2px" >
                            <span class="font-weight-bold" v-show="v.scaleStatus==1" >
                              出仓:{{activeTab===0?GetNumByUnit(v.reduceWeight, "g", "kg"):v.reduceNumber}}{{activeTab===0?'kg':v.unitName}}</span>
                            <span class="font-weight-bold" v-show="v.returnStatus==1" style="margin-left:10px">
                              退仓:{{activeTab===0?GetNumByUnit(v.returnWeight, "g", "kg"):v.returnNumber}}{{activeTab===0?'kg':v.unitName}}</span>
                          </div>
                        </div>
                      
                          
                          <div class="entry-button" v-show="v.scaleStatus==0" @click="entryClick(v,1)">出仓</div>
                          <div class="entry-button" v-show="v.scaleStatus==1&&v.returnStatus!=1&&v.goodsIsSeasoning==0" @click="entryClick(v,2)">退仓</div>
                      </div>
                    </el-card>
                  <div class="status-box" :class="{inactivestatus:v.scaleStatus!=0}"> {{v.goodsIsSeasoning==0&&v.returnStatus==1?'已退仓':v.scaleStatus==1?'已出仓':'待出仓'}}</div>

               </div>
               </div>
              </div>
            <el-empty description="暂无数据" v-if="tableData.length==0" />
            </el-scrollbar>
          </el-main>
        </div>
        <!-- 入仓弹框 -->
        <scale-dialog ref="scaleDialogRef"  @onSubmit="submit" />
              <!-- 设置弹框 -->
      <set-dialog ref="setDialogRef" />
    </el-container>
  </template>
    
    <script lang="ts" setup>
  import { ref ,getCurrentInstance } from "vue";
  import { useRouter } from "vue-router";
  import { ElMessage, ElMessageBox  } from 'element-plus'
  import scaleDialog from "@/views/warehouse/scaleDialog.vue";
  import { reduceWarehouseList,addscale,initScale ,returnwarehouse} from "@/api/outMaterial.js";
  import { getNowFormatDate, getTomorrowDate } from "@/utils/time";
  import { dicts } from "@/utils/getDict";
  //获取时间
  import {parseTime} from "@/utils/time";
  // g转kg
  import { GetNumByUnit, toFixedDigit,accSub } from "@/utils/uni.js";
  import setDialog from "@/views/warehouse/setDialog.vue";//setting弹框

  const { proxy } = getCurrentInstance();

  const router = useRouter();
  const dictObj = ref({}); //字典
  // 选项卡
  const tabsMenu=ref(['称重商品','计件商品'])
  // 当前选项卡下标
  let activeTab=ref(0)
  // 供应商
  let value=ref('四川蜀味茶韵供应链有限公司')
  // 入仓数量
  let num=ref()
  // 弹框
  const scaleDialogRef = ref();
  // 供应商选项
  const options = [
    {
      value: '土豆好吃有限公司',
      label: '土豆好吃有限公司',
    },
    {
      value: '四川蜀味茶韵供应链有限公司',
      label: '四川蜀味茶韵供应链有限公司',
    }
  ]
// 所有出仓单供应商下的子数据
const warehouseList = ref([]);
  // 当前渲染的出仓单数据 
  const tableData = ref([]);
  // 领料人
  const menuList = ref([]);
  //选择的领料人
  const menuActive = ref("0");
  // 偏离值的范围值
const range=ref(0)
// 偏离值初始化开关 1为开启 0为关闭
const offsetState=ref(0)
// 设置弹框
const setDialogRef = ref(null);
  // 设置
  const setClick=() => {
    setDialogRef.value.open({},1);
  }
  //获取字典值
const dictsFun = async () => {
  dictObj.value = await dicts(
    ["all_unit_type"],
    dictObj.value
  );
}
dictsFun()
  // 商品选项点击
  const handleClick = (index:number) => {
    activeTab.value=index;
    tableData.value=[]
    selectedMenu()
  }
  // 选择领料人
  const handleSelect = (index:string) => {
    menuActive.value=index+''
    tableData.value=[]
    selectedMenu()
  }
  // 秤端初始化
const initScaleList = async () => {
  try {
  const res = await initScale()
  range.value = res.data.offset;
  offsetState.value = res.data.offsetState;
  } catch (error) {
    
  }

}
initScaleList()
  // 返回
  const closeBtnCLick=() => {
    router.push("/");
  }
  // 入仓
  const entryClick=(row:any,type:number)=> {
   let isWeight=activeTab.value===0?true:false
      scaleDialogRef.value.open(row,type,isWeight);
  }
  // 
  const getScaleList = async () => {  
  // 当天时间
  const date = new Date();
  // 格式化时间
  const dayTime = parseTime(date, "{y}-{m}-{d}");

  // 明日时间
  let endTime = parseTime(
    getNowFormatDate(getTomorrowDate(date)),
    "{y}-{m}-{d}"
  );

  // 请求参数
  const params = {
      pageNum: 1,
      pageSize: 2000,
      params: {
        beginTime: dayTime + " 00:00:00",
        endTime: endTime + " 23:59:59",
      },
      status: 0
  }
   reduceWarehouseList(params).then(res => {
    if(res.code===200){
      const rows=res.rows

     let {treeData,data}= entryDeconstruction(rows)
     const infoList=data.filter(item=>!item.warehouseReduceRecordInfoList)
     menuList.value=infoList.filter((item,index)=>infoList.findIndex(i=>i.receiptorUserId===item.receiptorUserId)===index)
    //  所有出仓单供应商下的子数据
    warehouseList.value=infoList

    tableData.value=[]
    selectedMenu()

    }else{
      ElMessage.error(res.msg)
    }
   }).catch(err => {
    // ElMessage.error(err.message)
  })
  }
  getScaleList()
  // 入仓组装数据
  const entryDeconstruction=(data:any=[],arr:any=[])=>{
  data.forEach((item:any,index:number)=>{
    arr.push(item) //扁平化数据
  if(item.warehouseReduceRecordInfoList&&item.warehouseReduceRecordInfoList.length>0){
    entryDeconstruction(item.warehouseReduceRecordInfoList,arr)
   }
  })
  return {treeData:data,data:arr}
}
// 过滤对应的领料人员
const selectedMenu=()=>{
  const activeMenuObj=menuList.value[menuActive.value]
  let weightData=['0','1','2','13','14']
    const unitList=dictObj.value.all_unit_type||[]
    // 过滤出字典表中为计重单位的数据
    const dictData=unitList.filter(item=>!weightData.includes(item.dictValue))||[]
    // 计件单位
    const dicList=dictData.map(item=>item.dictLabel)||[]
   //  过滤出对应领料人的数据
   const list=warehouseList.value.filter(item=>item.receiptorUserId===activeMenuObj.receiptorUserId)
  //  获取供应商
   const supplierCcCodeList=list.map((item)=>{return {supplierCcCode:item.supplierCcCode,warehouseReduceRecordInfoList:[]}})
  //  去重
   const supplierList=supplierCcCodeList.filter((item,index)=>supplierCcCodeList.findIndex(i=>i.supplierCcCode===item.supplierCcCode)===index)
  //  重新组装数据
   supplierList.forEach((item,index)=>{
    const warehouseReduceRecordInfoList=list.filter(i=>i.supplierCcCode===item.supplierCcCode)
    item.warehouseReduceRecordInfoList=filterData(warehouseReduceRecordInfoList,dicList)
   })

  //  过滤出对应供应商的数据没有商品数据

   tableData.value=supplierList.filter(item=>item.warehouseReduceRecordInfoList.length>0)
  }
  // 过滤出计重或几件商品
const filterData=(data:any,dicList:any=[])=>{
  const unitList=dictObj.value.all_unit_type||[]
  data.forEach((item:any,index:number)=>{
    let unitObj=unitList.find(i=>i.dictValue==item.unit)||{}
    let reduceUnitObj=unitList.find(i=>i.dictValue==item.reduceUnit)||{}
     item.unitOrderName=unitObj.dictLabel||''
     item.unitName=reduceUnitObj.dictLabel||''
  })

    if(activeTab.value==0)return data.filter(item=>!dicList.filter(i=>item.specFullName.includes(i)).length&&item.warehouseType!=2)  
     return  data.filter(item=>dicList.filter(i=>item.specFullName.includes(i)).length>0&&item.warehouseType!=2)
}
        // 截取规格
const unitSplic=(unitName:string,item:any)=> {
  
      if (!unitName) return "";
      // 过滤字符串中的数字
      const str = unitName.replace(/\d+/g, "");
      let arr = str.split("*") || [];
      if(item&&item.goodsIsSeasoning==1){
        if(arr.length>1)return arr[arr.length-2]
        return arr[arr.length-1]
      }
      if (arr.length>0) return arr[0];
      return  "";
}

// 确认出仓
const submit = (row:any,type:number) => {
  const data=JSON.parse(JSON.stringify(row))
  data.goodsMode=activeTab.value
  // 当前选择需要出仓单
  const infoList=data.infoList.filter(item=>data.checkList.includes(item.reduceInfoId))||[]
  data.infoList=infoList
  delete data.checkList

  if(type===1){ //出仓
    submitEntry(data)
  }else{ //退仓
    confirmBack(data)
  }
  
}

// 出仓事件
const submitEntry = (row:any) => {
  const userId = localStorage.getItem("userId");
  row.reduceUserId=userId
  // 判断是否启用偏离值
  if (offsetState.value === 1) {
    offsetCompare(row);
  } else {
    confirmClick(row);
  }
}
// 启用偏离值进行比较
const offsetCompare = (data) => {
  // / 取 偏离值的绝对值
  // 理论值
  let theoryVal=activeTab.value==0?data.orderNo:data.unitOrderNo
  // 实际值
  let actualVal=activeTab.value==0?data.addWeight:data.addNumber
  // theoryVal 理论重量
  const num = accSub(theoryVal, actualVal);
  
  const numbe = range.value * -1;
  if (num >= numbe && num <= range.value) {
    confirmClick(data);
  } else {
    let message =
      num < range.value ? "多了！！！" : num > numbe ? "少了！！！" : "";
    proxy.$message.warning(message);
    // row.butLoad = false;
  }
}

// 出仓确认

const confirmClick = (data:any) => {
    // 转换单位 kg->g （实际重量）
  if(activeTab.value==0){ //计重
    data.addWeight = GetNumByUnit(data.weigth, "kg", "g");
  }else{
    data.addNumber = data.weigth;
  }
  ElMessageBox.alert('是否确认出库?','提示',{
      confirmButtonText: "确认",
      cancelButtonText: "取消",
      showClose: false,
      showCancelButton:true,
      closeOnPressEscape:false,
      type: "warning",
      buttonSize: "large",
      cancelButtonClass: "cancel-button-class",
      customClass: "custom-class-text",
      confirmButtonClass: "confirm-button-class el-button--success",
  }).then(() => {
    data.scaleStatus = 1;
          addscale(data).then(res => {
            if (res.code === 200) {
              ElMessage.success(res.msg);
              getScaleList();
            } else {
              ElMessage.error(res.msg);
      }
    });
  }).catch(() => {
    console.log('cancel');
  });

}

// 确认退仓
const confirmBack = (data:any) => {
  const userId = localStorage.getItem("userId");
  data.returnMaterialId=userId
  data.goodsUsed=data.checked
    // 转换单位 kg->g （实际重量）
  if(activeTab.value==0){ //计重
    data.returnWeight = GetNumByUnit(data.weigth, "kg", "g");
    data.goodsUseWeight=data.goodsUsed?data.returnWeight:0
  }else{
    data.returnNumber = data.weigth;
    data.goodsUseNumber=data.goodsUsed?data.splitWeigth:0

  }
  
  // 实际出仓值
  let theoryVal=activeTab.value==0?data.reduceWeight:data.reduceNumber
  // 实际值
  let actualVal=activeTab.value==0?data.returnWeight:data.returnNumber
  if(theoryVal<actualVal)return ElMessage.error('退仓数量不能大于出仓数量!!')
  delete data.infoList
  delete data.check
  delete data.splitWeigth
  ElMessageBox.alert('是否确认退库?','提示',{
      confirmButtonText: "确认",
      cancelButtonText: "取消",
      showClose: false,
      type: "warning",
      closeOnPressEscape:false,
      showCancelButton:true,
      buttonSize: "large",
      cancelButtonClass: "cancel-button-class",
      customClass: "custom-class-text",
      confirmButtonClass: "confirm-button-class el-button--success",
  }).then(() => {
    data.returnStatus = 1;
    returnwarehouse(data).then(res => {
    if (res.code === 200) {
      ElMessage.success(res.msg);
      getScaleList();
    } else {
      ElMessage.error(res.msg);
    }
   })
  }).catch(() => {
    console.log('cancel');
  });
}

  </script>
    
    <style scoped>
    .layout-container-demo {
      font-size: 25px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      position: fixed;
      width: 100%;
      height: 100vh;
      top: 0;
    }
  .layout-container-demo .el-header {
    position: relative;
    /* background-color: var(--el-color-primary-light-7); */
    background-color:rgba(6, 172, 83, 1) ;
    color: var(--el-text-color-primary);
    height:65px
  }
  .layout-container-demo .el-aside {
    color: var(--el-text-color-primary);
    background: #fff;
  }
  .layout-container-demo .el-menu {
    border-right: none;
  }
  .layout-container-demo .el-main {
    padding: 0;
  }
  .layout-container-demo .toolbar {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    right: 20px;
  }
  .header-button{
      display: inline-block;
      padding: 6px 15px; 
      color: #fff;
      border-radius: 5px;
      border: 1px solid #fff;
    cursor: pointer;
  
  }
  .goodsTabs{
      background:#fff ;
      color: #06AC53;
      padding: 2px;
      border-radius: 5px;
      margin-left: 40px;
    cursor: pointer;
  
  }
  .tabsText{
      padding: 5px 20px;
  }
  .activeTabs{
      color: #fff;
      background: #06AC53;
      border-radius: 5px;
      
  }
  .supplierSelect{
      width: 21%;
      margin-left: 20px;
  }
  >>>.supplierSelect .el-input{
      font-size: 25px;
      height: 44px;
  
  }
  >>>.supplierSelect .el-input__inner, .el-select-dropdown__item.selected{
      color: #06AC53;
  
  }
  .menu-item{
      border-bottom: 1px solid #eee;
      font-size: 22px;
  }
  
  .el-menu-item.is-active{
      background: #1cb563d6;
      /* color: #fff; */
  
  }
  .cont-title{
      border-bottom: 1px solid rgba(121, 121, 121, 1);
      width: 20%;
  }
  .cont-card{
      margin:10px 0;
      background: rgba(240, 255, 247, 1);
      border-color: rgba(3, 172, 84, 1);
      position: relative;
      width: calc(100% - 31px);
      min-height: calc(100% - 21px);
  }
  >>> .cont-card .el-card__body{
      padding:15px  10px 10px;
  }
  .card-title{
      color: #03AC54;
      margin-bottom: 10px;
  }
  .font-weight-bold{
      font-weight: bold;
  }
  .card-left{
      margin-left: 2px;
  }
  .card-bottom{
      font-size:18px ;
      margin-top: 10px;
      align-items: flex-end;
  }
  .entry-button{
      color: #03AC54;
      border:1px solid rgba(3, 172, 84, 1);
      border-radius: 5px;
      padding: 4px 10px;
    cursor: pointer;
  
  }
  .entry-text{
      font-size:16px ;
  }
  .pirce-text{
      margin: 5px;
      font-size: 16px;
  }
  >>>.el-input-number__increase,>>> .el-input-number__decrease {
      border-radius: 50%;
  }
  
  >>> .card-bottom .el-input__wrapper{
      box-shadow: none;
      background: transparent;
  }
  
  >>> .card-bottom  .el-input__inner{
      background: #fff;
  }

  .entry-card-item{
      position: relative;
      width:calc(100% / 4.4);position:relative;margin-right:10px;
  }
  .status-box{
      font-size: 18px;
      background: #00c988;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
      color: #fff;
      position: absolute;
      width: 29px;
      text-align: center;
      top: 50%;
      right: 0.45px;
      /* height: 125px; */
      transform: translateY(-50%);
      padding: 25px 0;
  }
  .inactivestatus{
      background: #d9dbe0;
  }
  
  
  /* 屏幕小于1280px */
  @media screen and (max-width: 1280px) {
    .cont {
      width: 90%;
      margin: 0 auto;
    }
  }
  /*  屏幕小于1520或大于1280 */
  @media screen and (max-width: 1520px) and (min-width: 1280px) {
    .cont {
      width: 90%;
      margin: 0 auto;
    }
  }
  /* 屏幕大于1520px */
  @media screen and (min-width: 1520px) {
    .cont {
      width: 75%;
      margin: 0 auto;
    }
  }
  </style>
  
